import { render, staticRenderFns } from "./NCLDMathScienceCollaborative2021.vue?vue&type=template&id=8a8fbb8e&scoped=true"
import script from "./NCLDMathScienceCollaborative2021.vue?vue&type=script&lang=js"
export * from "./NCLDMathScienceCollaborative2021.vue?vue&type=script&lang=js"
import style0 from "./NCLDMathScienceCollaborative2021.vue?vue&type=style&index=0&id=8a8fbb8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8fbb8e",
  null
  
)

export default component.exports